import { useContext } from "react";
import styles from "../DeleteProduct/DeleteProductModal.module.css";
import { deleteExpiredProductsByIds,  deleteAllExpiredProductsByStoreId } from '../../../hooks/ExpiredProduct';
import { ExpiredProductContext } from '../../../context/ExpiredProductContext';
import { StoresContext } from '../../../context/StoresContext';

function Modal({ closeModal }) {
  const { 
    selectedStore,
   } = useContext(StoresContext);

   const { 
    expiredproductIds,
    setIsDeletedExpiredProduct
   } = useContext(ExpiredProductContext);
     
  const deleteExpiredProductsByListId = async () => {
    if(expiredproductIds != null && expiredproductIds.length > 0) {
      try {
        const response = await deleteExpiredProductsByIds( expiredproductIds ); 
        if (response) {
          setIsDeletedExpiredProduct(true)
          closeModal()
        } else {
          setIsDeletedExpiredProduct(false)
          console.error("Error to delete products:");
        }
      } catch (error) {
        setIsDeletedExpiredProduct(false)
        console.error("Error to delete selected products:", error);
      }
    }
  }

  const deleteAllExpiredProductsByStore = async () => {
    if(selectedStore != null) {
        try {
          const response = await deleteAllExpiredProductsByStoreId(selectedStore.id); 
          if (response) {
            setIsDeletedExpiredProduct(true)
            closeModal()
          } else {
            setIsDeletedExpiredProduct(false)
            console.error("Error to delete products:");
          }
      } catch (error) {
        setIsDeletedExpiredProduct(false)
          console.error("Error to delete selected products:", error);
      }
    }
  }

  const getDeleteMessage = () => {
    if (expiredproductIds != null && expiredproductIds.length > 0) {
      return "Deseja excluir os item(s) selecionados da loja?";
    } else if(selectedStore != null && expiredproductIds.length === 0) {
      return "Deseja excluir todos os produtos validados da loja?";
    }else {
        return null;
    }
  };

  return (
    <div className={styles.modalBackground}>
      <div className={styles.modalContainer}>
        <div className={styles.content}>
          <h2>{ getDeleteMessage() }</h2>
          <p>{selectedStore && `Id: ${selectedStore.id}`}</p>
          <p>{selectedStore && `Nome da loja: ${selectedStore.name}`}</p>
          <p>{selectedStore && `CNPJ: ${selectedStore.cnpj}`}</p>
          <p>{selectedStore && `Telefone: ${selectedStore.phone}`}</p>

        </div>

        <div className={styles.buttonContent}>
        <button 
          className={styles.buttonConfirm}
          onClick={() => {
            if (expiredproductIds.length >= 1) {
              deleteExpiredProductsByListId();
            } else {
              deleteAllExpiredProductsByStore();
            }
          }}
        >
          Deletar
        </button>
          <button onClick={ closeModal } className={styles.buttonCancel}>Cancelar</button>
        </div>
      </div>
    </div>
  );
}

export default Modal;
